module.exports = __webpack_public_path__ + "static/media/logo-navbar-dark.b3a421e6.svg";